module.exports = __webpack_public_path__ + "static/media/bmp.be859415.png";